import type { FeedbackType } from './feedbackHelpers';
import { sparkAssetUrl } from '../../utils/sparkAssetUrl';

const FILLED_FEEDBACK_ICON_SLUGS: Record<FeedbackType, string> = {
  success: 'feedback-success-filled',
  warning: 'feedback-warning-filled',
  info: 'feedback-info-filled',
  error: 'feedback-error-filled',
};

/** Figma Feedback Icon (`677:65813`) — filled status glyphs used in Toast. */
export function FeedbackIcon({
  feedbackType,
  size = 24,
  className = '',
}: {
  feedbackType: FeedbackType;
  /** Rendered size in pixels. Defaults to 24 (medium). */
  size?: number;
  className?: string;
}) {
  const slug = FILLED_FEEDBACK_ICON_SLUGS[feedbackType];

  return (
    <img
      src={sparkAssetUrl(`icons/${slug}-medium.svg`)}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={['spark-feedback-icon', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size }}
    />
  );
}
